import { Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const CalcBanner: FunctionalComponent<{
  title: string
  desc: string
  btn: string
  link: string
}> = props => {
  return (
    <UI.Panel class={styles.root} type='user' shadow>
      <Row gap={15}>
        <Row gap={5}>
          <Text
            as='h2'
            fontSize={20}
            fontWeight={600}
            textAlign='center'
          >
            {props.title}
          </Text>
          <UI.Holder maxWidth={400}>
            <Text
              as='p'
              fontSize={16}
              textAlign='center'
            >
              {props.desc}
            </Text>
          </UI.Holder>
        </Row>

        <UI.Button
          size='m'
          type='primary'
          link={props.link}
        >
          {props.btn}
        </UI.Button>
      </Row>
    </UI.Panel>
  )
}
